import React from 'react';
import { FDPaper, FDSecondaryActionIconButton, FDStack } from '@facet-wealth/design';
import ScenarioQuestionContent
  from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedWrapperTemplate/ScenarioQuestionPicker/Content';
import DataContainer from 'Components/UI/DataContainer';
import Drawer from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Drawer';
import { useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { DataValueMap } from 'Helpers/Testing';
import { useRightColumnContext } from 'Context/RightColumnContext';
import {
  useScenarioQuestionMessageContext,
} from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedWrapperTemplate/ScenarioQuestionPicker/Context';
import { v4 as uuid } from 'uuid';

const ScenarioQuestionDrawer = () => {
  const theme = useTheme();

  const {
    rightColumnCollection,
    showRightColumnCollection,
    clearRightColumnCollection,
    rightColumnCollectionLoading,
    rightColumnCollectionError,
  } = useRightColumnContext();

  const scenarioQuestionResource = rightColumnCollection.resources().head();
  const {
    draftMessageResource,
    isMessageSending,
    handleSendMessage,
    handleContentChange,
    isMessageLoading,
    messageLoadingError,
  } = useScenarioQuestionMessageContext(scenarioQuestionResource);

  // temporary fix, forces DataContainer to repaint on prop updates
  const sqdKey = uuid();

  return (
    <Drawer
      open={showRightColumnCollection && !isMessageLoading}
      onClose={clearRightColumnCollection}
      anchor={'right'}
    >
      <FDPaper
        flexGrow={1}
        appearance={'flat'}
        color={'subtle'}
        rounded={false}
        maxWidth={theme.dimensions.md}
        {...DataValueMap.init('scenario-question-drawer').build()}
      >
        <FDStack direction={'column'} paddingX={4}>
          <FDStack justifyContent={'flex-end'}>
            <FDSecondaryActionIconButton
              onClick={clearRightColumnCollection}
              icon={'close'}
            />
          </FDStack>
          <DataContainer
            key={sqdKey}
            component={ScenarioQuestionContent}
            componentProps={{
              scenarioQuestionResource,
              draftMessageResource,
              isMessageSending,
              handleSendMessage,
              handleContentChange,
            }}
            loading={isMessageLoading || rightColumnCollectionLoading}
            loadingError={messageLoadingError || rightColumnCollectionError}
            backgroundColor={'lightGray'}
          />
        </FDStack>
      </FDPaper>
    </Drawer>
  );
};

ScenarioQuestionDrawer.defaultProps = {
};

ScenarioQuestionDrawer.propTypes = {};

export default ScenarioQuestionDrawer;
